// Gates the GCal agenda toggle behind the Free-tier wall.
import { useState } from 'react';

export function usePlanPageGCalWall({ canUseAgenda, toggleAgenda }) {
  const [gcalWallOpen, setGcalWallOpen] = useState(false);

  const handleToggleAgenda = () => {
    if (!canUseAgenda) {
      setGcalWallOpen(true);
      return;
    }
    toggleAgenda();
  };

  const closeGcalWall = () => setGcalWallOpen(false);

  return { gcalWallOpen, closeGcalWall, handleToggleAgenda };
}
